import React, {useState} from 'react'
import Chart from '@components/chart'
import './index.less'

export default function HomeLeft() {
  const [regionChartData, setRegionChartData] = useState([
    {type: '1-3秒', value: 0.16},
    {type: '4-10秒', value: 0.125},
    {type: '11-30秒', value: 0.24},
    {type: '31-60秒', value: 0.19},
    {type: '1-3分', value: 0.22},
    {type: '3-10分', value: 0.05},
    {type: '10-30分', value: 0.01},
    {type: '30+分', value: 0.015},
  ])
  const [projectTypeChartData, setProjectTypeChartData] = useState([
    {item: '事例一', count: 40, percent: 0.4},
    {item: '事例二', count: 21, percent: 0.21},
    {item: '事例三', count: 17, percent: 0.17},
    {item: '事例四', count: 13, percent: 0.13},
    {item: '事例五', count: 9, percent: 0.09},
  ])
  // 渲染区域柱状图
  const renderRegionChart = (instance, opts) => {
    instance.data(opts.data);
    instance.scale('value', {
      nice: true,
    });
    instance.axis('type', {
      tickLine: null,
    });
    
    instance.axis('value', {
      label: {
        formatter: (val) => {
          return +val * 100 + '%';
        },
      },
    });
    
    instance.tooltip({
      showMarkers: false,
    });
    instance.interaction('element-active');
    
    instance.legend(false);
    instance
      .interval({
        background: {
          style: {
            radius: 8,
          },
        },
      })
      .position('type*value')
      .color('type', (val) => {
        if (val === '10-30分' || val === '30+分') {
          return '#ff4d4f';
        }
        return '#2194ff';
      })
      .label('value', {
        content: (originData) => {
          const val = parseFloat(originData.value);
          if (val < 0.05) {
            return (val * 100).toFixed(1) + '%';
          }
        },
        offset: 10,
      });
    
    instance.render();
  }

  // 渲染项目类型分布饼图
  const renderProjectTypeChart = (instance, opts) => {
    instance.coordinate('theta', {
      radius: 0.75,
    });
    
    instance.data(opts.data);
    
    instance.scale('percent', {
      formatter: (val) => {
        val = val * 100 + '%';
        return val;
      },
    });
    
    instance.tooltip({
      showTitle: false,
      showMarkers: false,
    });
    
    instance
      .interval()
      .position('percent')
      .color('item')
      .label('percent', {
        content: (data) => {
          return `${data.item}: ${data.percent * 100}%`;
        },
      })
      .adjust('stack');
    
    instance.interaction('element-active');
    
    instance.render();
  }
  return (
    <div className="light-home-left">
      <div className="light-block">
        <div className="light-block-title">
          勇电数据大屏
        </div>
        <div className="light-block-con">
          <div className="light-block-subtitle">
            项目数
          </div>
          <div className="light-block-num">
            23247
          </div>
          <div className="light-block-subtitle">
            项目用灯数
          </div>
          <div className="light-block-num">
            23,247
          </div>
        </div>
      </div>
      <div className="light-block">
        <div className="light-block-title">
          项目区域分布
        </div>
        <div className="light-block-con">
          <Chart padding={[24, 16, 24, 48]} renderChart={renderRegionChart} style={{height: 250}} data={regionChartData} />
        </div>
      </div>
      <div className="light-block">
        <div className="light-block-title">
          项目类型分布
        </div>
        <div className="light-block-con">
          <Chart padding={[24, 16, 24, 48]} renderChart={renderProjectTypeChart} style={{height: 250}} data={projectTypeChartData} />
        </div>
      </div>
    </div>
  )
}